import { TextInputType, TextFieldValidationType } from "@/commonTypes/question";
import { DECIMAL_VALIDATION_TYPES } from "@/validation/textFieldSchemas";

export type InputMode = "text" | "numeric" | "decimal" | "email" | "tel";

export interface InputAttributes {
  htmlType: string | null;
  inputMode: InputMode | null;
  autoComplete: string | null;
}

/**
 * Derives htmlType, inputMode, and autoComplete from inputType and validationType
 * for better mobile UX.
 *
 * - For numeric fields, uses type="text" (not "number") to avoid browser spinners
 * - inputMode="numeric" shows 0-9 keyboard (no decimal key)
 * - inputMode="decimal" shows 0-9 keyboard with decimal key
 */
export function getInputAttributes(
  inputType: TextInputType,
  validationType?: TextFieldValidationType,
): InputAttributes {
  switch (inputType) {
    case TextInputType.EMAIL:
      return { htmlType: "email", inputMode: "email", autoComplete: "email" };
    case TextInputType.PHONE:
      return { htmlType: "tel", inputMode: "tel", autoComplete: "tel" };
    case TextInputType.NUMBER:
      // Use validationType to distinguish integer vs decimal keyboards
      if (validationType && DECIMAL_VALIDATION_TYPES.has(validationType)) {
        return { htmlType: "text", inputMode: "decimal", autoComplete: null };
      }
      // Default to numeric (integers)
      return { htmlType: "text", inputMode: "numeric", autoComplete: null };
    default:
      return { htmlType: null, inputMode: null, autoComplete: null };
  }
}

